export default __webpack_public_path__ + "static/media/James_Web.6f913f46.jpg";